<template>
  <div class="sidebar-filter">
    <div class="filter-group" v-for="(label, section) in filterSections" :key="section">
      <button @click="toggleSection(section)" class="filter-button">
        {{ label }}
        <span :class="{'arrow-up': isSectionVisible(section), 'arrow-down': !isSectionVisible(section)}"></span>
      </button>
      <transition name="accordion">
        <div v-show="isSectionVisible(section)" class="filter-content">
          <div class="form-check" v-for="item in getItems(section)" :key="item">
            <div class="checkbox checkbox-css checkbox-success">
              <input
                type="checkbox"
                :id="`cssCheckbox_${item}`"
                v-model="categories"
                :value="item"
              />
              <label :for="`cssCheckbox_${item}`" class="text-capitalize">{{ item }}</label>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  props: ["annotatedFilter"],
  data() {
    return {
      categories: [],
      visibleSections: {
        modality: false,
        organ: false,
        pathology: false,
      },
      filterSections: {
        modality: "Modality",
        organ: "Organ",
        pathology: "Pathology",
      },
    };
  },
  computed: {
    modalities() {
      return ["MRI", "Xray", "CT", "EEG", "ECG"];
    },
    organs() {
      return ["lung", "heart", "arteries", "trachea"];
    },
    pathologies() {
      return ["pulmonary disease", "arterial disease", "heart disease"];
    },
  },
  methods: {
    toggleSection(section) {
      this.$set(this.visibleSections, section, !this.visibleSections[section]);
    },
    isSectionVisible(section) {
      return this.visibleSections[section];
    },
    getItems(section) {
      switch (section) {
        case "modality":
          return this.modalities;
        case "organ":
          return this.organs;
        case "pathology":
          return this.pathologies;
        default:
          return [];
      }
    },
    buildConditions() {
      const conditions = {};

      if (this.categories.length > 0) {
        conditions.categories = {
          $in: this.categories.map(it => it.toLowerCase()),
        };
      }

      if (this.annotatedFilter && this.annotatedFilter.annotated !== "all") {
        conditions.annotated = this.annotatedFilter.annotated;
      }

      this.$emit("conditionsChange", conditions);
    },
  },
  watch: {
    categories: 'buildConditions',
  },
};
</script>
<style scoped>
.sidebar-filter {
  padding: 15px;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
}

.filter-group {
  margin-bottom: 15px;
}

.filter-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  background-color: transparent;
  border: 1px solid #9ea3b3;
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 20px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.filter-button:hover {
  background-color: #E95913;
  border-color: #E95913;
  color: white;
}

.filter-content {
  margin-top: 10px;
  overflow: hidden;
  width: 100%;
}

.arrow-up::before {
  content: url(../assets/chevron-up.svg);
  margin-left: 10px;
  margin-right: -10px;
}

.arrow-down::before {
  content: url(../assets/chevron-down.svg);
  margin-left: 10px;
  margin-right: -10px;
}

.filter-button:hover .arrow-down::before {
  content: url(../assets/chevron-down-white.svg);
}

.filter-button:hover .arrow-up::before {
  content: url(../assets/chevron-up-white.svg);
}

.checkbox-css {
  display: flex;
  align-items: center;
}

.checkbox-css input[type="checkbox"] {
  margin-right: 10px;
}

.accordion-enter-active, .accordion-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.accordion-enter, .accordion-leave-to {
  max-height: 0;
}

.accordion-enter-to, .accordion-leave {
  max-height: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue